import { Box } from "@mui/material";

const TwoFactorAuthenticationPage = () => {
  return <Box></Box>;
};
export default TwoFactorAuthenticationPage;
